import React, { useState, useEffect } from 'react';
import axios from 'axios';
import UserTypesChart from './components/UserTypesChart';
import { MdPerson, MdDevices, MdBusiness, MdPayment, MdReceipt, MdAttachMoney, MdVerifiedUser, MdSwapHoriz, MdList, MdPhoneAndroid, MdHistory, MdDashboard, MdEmail, MdSettings, MdSupport } from 'react-icons/md';
import { API_CONFIG } from './config/api';

import Sidebar from './components/Sidebar';
import Header from './components/Header';
import DashboardView from './components/DashboardView';
import UsersView from './components/UsersView';
import DevicesView from './components/DevicesView';
import MMDAsView from './components/MMDAsView';
import ZonesView from './components/ZonesView';
import GroupsView from './components/GroupsView';
import RevenueOfficersView from './components/RevenueOfficersView';
import PaymentMethodsView from './components/PaymentMethodsView';
import ReceiptsView from './components/ReceiptsView';
import RevenueItemsView from './components/RevenueItemsView';
import TicketValidationsView from './components/TicketValidationsView';
import TransactionsView from './components/TransactionsView';
import UssdSessionsView from './components/UssdSessionsView';
import AuditLogsView from './components/AuditLogsView';
import TradersView from './components/TradersView';
import SearchableDropdown from './components/SearchableDropdown';
import UserSidebarPermissionsModal from './components/UserSidebarPermissionsModal';
import EmailSettingsView from './components/EmailSettingsView';
import SettingsView from './components/SettingsView';
import SupportTicketsView from './components/SupportTicketsView';
import AddDeviceModal from './AddDeviceModal';
import AddMmdaModal from './AddMmdaModal';
import AddUserModal from './components/AddUserModal';
import EditUserModal from './components/EditUserModal';
import AddGroupModal from './components/AddGroupModal';
import EditGroupModal from './components/EditGroupModal';
import AddRevenueOfficerModal from './components/AddRevenueOfficerModal';
import EditRevenueOfficerModal from './components/EditRevenueOfficerModal';
import AddTraderModal from './components/AddTraderModal';
import EditTraderModal from './components/EditTraderModal';
import AddZoneModal from './components/AddZoneModal';
import EditZoneModal from './components/EditZoneModal';

const SuperAdminDashboard = ({ user, onUserChange }) => {
  // Placeholder declarations for missing variables and functions
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [groupsSearchTerm, setGroupsSearchTerm] = useState('');
  const [revenueOfficersSearchTerm, setRevenueOfficersSearchTerm] = useState('');
  const [tradersSearchTerm, setTradersSearchTerm] = useState('');
  const [deviceSearchTerm, setDeviceSearchTerm] = useState('');
  const [paymentMethodSearchTerm, setPaymentMethodSearchTerm] = useState('');
  const [receiptSearchTerm, setReceiptSearchTerm] = useState('');
  const [revenueItemSearchTerm, setRevenueItemSearchTerm] = useState('');
  const [ticketValidationSearchTerm, setTicketValidationSearchTerm] = useState('');
  const [transactionSearchTerm, setTransactionSearchTerm] = useState('');
  const [ussdSessionSearchTerm, setUssdSessionSearchTerm] = useState('');
  const [auditLogSearchTerm, setAuditLogSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const [groupsStatusFilter, setGroupsStatusFilter] = useState('All');
  const [groupsMmdaFilter, setGroupsMmdaFilter] = useState('All');
  const [revenueOfficersStatusFilter, setRevenueOfficersStatusFilter] = useState('All');
  const [revenueOfficersMmdaFilter, setRevenueOfficersMmdaFilter] = useState('All');
  const [tradersStatusFilter, setTradersStatusFilter] = useState('All');
  const [tradersMmdaFilter, setTradersMmdaFilter] = useState('All');
  const [zoneSearchTerm, setZoneSearchTerm] = useState('');
  const [zoneStatusFilter, setZoneStatusFilter] = useState('All');
  const [zoneMmdaFilter, setZoneMmdaFilter] = useState('All');
  const [isAddDeviceModalOpen, setIsAddDeviceModalOpen] = useState(false);
  const [isAddMmdaModalOpen, setIsAddMmdaModalOpen] = useState(false);
  const [isAddRevenueOfficerModalOpen, setIsAddRevenueOfficerModalOpen] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editRevenueOfficer, setEditRevenueOfficer] = useState(null);
  const [isEditRevenueOfficerModalOpen, setIsEditRevenueOfficerModalOpen] = useState(false);
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedMmda, setSelectedMmda] = useState(null);
  const [roleMap, setRoleMap] = useState(new Map());
  const [mmdaMap, setMmdaMap] = useState(new Map());

  // New state for device edit modal
  const [editDevice, setEditDevice] = useState(null);
  const [isEditDeviceModalOpen, setIsEditDeviceModalOpen] = useState(false);
  const [mmdas, setMmdas] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  // New state for MMDA edit modal
  const [editMmda, setEditMmda] = useState(null);
  const [isEditMmdaModalOpen, setIsEditMmdaModalOpen] = useState(false);

  // New state for Zone edit modal
  const [editZone, setEditZone] = useState(null);
  const [isEditZoneModalOpen, setIsEditZoneModalOpen] = useState(false);

  // New state for Group edit modal
  const [editGroup, setEditGroup] = useState(null);
  const [isEditGroupModalOpen, setIsEditGroupModalOpen] = useState(false);
  const [zones, setZones] = useState([]);

  // New state for Trader edit modal
  const [editTrader, setEditTrader] = useState(null);
  const [isEditTraderModalOpen, setIsEditTraderModalOpen] = useState(false);
  const [groups, setGroups] = useState([]); // Add groups state
  
  const [editPaymentMethod, setEditPaymentMethod] = useState(null);
  const [isEditPaymentMethodModalOpen, setIsEditPaymentMethodModalOpen] = useState(false);
  const [popup, setPopup] = useState({ message: '', type: '' });
  const [editReceipt, setEditReceipt] = useState(null);
  const [isEditReceiptModalOpen, setIsEditReceiptModalOpen] = useState(false);
  const [editRevenueItem, setEditRevenueItem] = useState(null);
  const [isEditRevenueItemModalOpen, setIsEditRevenueItemModalOpen] = useState(false);
  const [editTicketValidation, setEditTicketValidation] = useState(null);
  const [isEditTicketValidationModalOpen, setIsEditTicketValidationModalOpen] = useState(false);
  const [editTransaction, setEditTransaction] = useState(null);
  const [isEditTransactionModalOpen, setIsEditTransactionModalOpen] = useState(false);
  const [editUssdSession, setEditUssdSession] = useState(null);
  const [isEditUssdSessionModalOpen, setIsEditUssdSessionModalOpen] = useState(false);
  const [editAuditLog, setEditAuditLog] = useState(null);
  const [isEditAuditLogModalOpen, setIsEditAuditLogModalOpen] = useState(false);
  const [nationalIdTypes, setNationalIdTypes] = useState([]); // New state for national ID types

  // User sidebar permissions modal state
  const [isUserSidebarPermissionsModalOpen, setIsUserSidebarPermissionsModalOpen] = useState(false);
  const [selectedUserForSidebar, setSelectedUserForSidebar] = useState(null);

   // Form state for editing user
   const [editForm, setEditForm] = useState({
    role_id: '',
    full_name: '',
    email: '',
    phone: '',
    status: '',
    created_at: '',
  });

  // Form validation errors
  const [formErrors, setFormErrors] = useState({});

  // Use state for logged-in user info (removed duplicate - using prop instead)


  const deviceSerialRef = React.useRef(null);
  const deviceStatusRef = React.useRef(null);
  const mmdaNameRef = React.useRef(null);
  const districtCodeRef = React.useRef(null);
  const regionRef = React.useRef(null);



  // Fetch all roles for the dropdown
  const fetchAllRoles = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/roles`, API_CONFIG);
      setRoles(response.data);
    } catch (err) {
      console.error('Failed to fetch roles:', err);
    }
  };

  // Fetch all MMDAs for the dropdown
  const fetchAllMmdas = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/mmdas`, API_CONFIG);
      setMmdas(response.data);
    } catch (err) {
      console.error('Failed to fetch MMDAs:', err);
    }
  };

  React.useEffect(() => {
    // Fetch all roles when component mounts
    fetchAllRoles();
    fetchAllMmdas();
    fetchAllUsers();
    fetchAllZones();
    fetchAllGroups(); // Fetch all groups
    fetchNationalIdTypes(); // Fetch national ID types
  }, []);

  const fetchAllZones = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/zones`, API_CONFIG);
      setZones(response.data);
    } catch (err) {
      console.error('Failed to fetch zones:', err);
    }
  };

  const handleZoneStatusUpdate = async (zoneId, newStatus) => {
    try {
      await axios.put(`${API_BASE_URL}/zones/${zoneId}/status`, { status: newStatus }, API_CONFIG);
      showPopup('Zone status updated successfully!', 'success');
      fetchAllZones(); // Re-fetch zones to update the table
    } catch (err) {
      console.error('Failed to update zone status:', err);
      showPopup('Failed to update zone status. Please try again.', 'error');
    }
  };

  const handleGroupStatusUpdate = async (groupId, newStatus) => {
    try {
      await axios.put(`${API_BASE_URL}/zonal-groups/${groupId}/status`, { status: newStatus }, API_CONFIG);
      showPopup('Group status updated successfully!', 'success');
      fetchAllGroups(); // Re-fetch groups to update the table
    } catch (err) {
      console.error('Failed to update group status:', err);
      showPopup('Failed to update group status. Please try again.', 'error');
    }
  };

  const fetchAllGroups = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/zonal-groups`, API_CONFIG);
      setGroups(response.data);
    } catch (err) {
      console.error('Failed to fetch groups:', err);
    }
  };

  const fetchNationalIdTypes = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/national-ids`, API_CONFIG);
      setNationalIdTypes(response.data);
    } catch (err) {
      console.error('Failed to fetch national ID types:', err);
    }
  };

   const fetchAllUsers = async () => {
     try {
      const response = await axios.get(`${API_BASE_URL}/users`, API_CONFIG);
      setUsers(response.data);
    } catch (err) {
      console.error('Failed to fetch users:', err);
    }
  };

  // Placeholder tables array and API_BASE_URL
  const tables = [
    { name: 'Dashboard', endpoint: '', icon: <MdDashboard size={20} /> },
    { name: 'Users', endpoint: '/users', icon: <MdPerson size={20}/> },
    {
      name: 'Manage MMDAs',
      icon: <MdBusiness size={20} />,
      subItems: [
        { name: 'MMDA List', endpoint: '/mmdas' },
        { name: 'MMDA Zones', endpoint: '/zones' },
        { name: 'Groups', endpoint: '/zonal-groups' },
        { name: 'Revenue Officers', endpoint: '/revenue-officers' },
        { name: 'Traders', endpoint: '/traders' },
      ],
    },
    { name: 'Payment Methods', endpoint: '/payment-methods', icon: <MdPayment size={20} /> },
    { name: 'Receipts', endpoint: '/receipts', icon: <MdReceipt size={20} /> },
    { name: 'Ticket Validations', endpoint: '/ticket-validations', icon: <MdVerifiedUser size={20} /> },
    { name: 'Transactions', endpoint: '/transactions', icon: <MdSwapHoriz size={20} /> },
    { name: 'USSD Sessions', endpoint: '/ussd-sessions', icon: <MdPhoneAndroid size={20} /> },
    { name: 'Audit Logs', endpoint: '/audit-logs', icon: <MdHistory size={20} /> },
    {
      name: 'Settings',
      icon: <MdSettings size={20} />,
      subItems: [
        { name: 'Devices', endpoint: '/devices' },
        { name: 'Revenue Items', endpoint: '/revenue-items' },
      ],
    },
    { name: 'Support', endpoint: '/support', icon: <MdSupport size={20} /> },
  ];
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';

  const [selectedTable, setSelectedTable] = useState(tables[0]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [errorDetails, setErrorDetails] = useState('');
  const [page, setPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);
  const pageSize = 10;
  const ITEMS_PER_PAGE = 7;

  // State for dashboard summary data
  const [dashboardData, setDashboardData] = useState({
    usersCount: 0,
    transactionsCount: 0,
    mmdasCount: 0,
    userTypesData: [],
    mmdaZoneGroupData: [],
  });

  // Implemented handleLogout function
  const handleLogout = () => {
    // Clear authentication tokens or user data from localStorage/sessionStorage
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    // Redirect to login page
    window.location.href = '/login';
  };

  // Handle sidebar management for specific users
  const handleManageSidebar = (selectedUser) => {
    setSelectedUserForSidebar(selectedUser);
    setIsUserSidebarPermissionsModalOpen(true);
  };

  // Function to handle MMDA login - allows super admin to login as specific MMDA
  const handleMmdaLogin = (mmdaData) => {
    // Create a temporary MMDA user object
    const mmdaUser = {
      user_id: 999999, // Temporary ID for super admin acting as MMDA
      role_name: 'MMDA',
      role_id: 3, // Assuming MMDA role ID is 3
      full_name: `Super Admin (${mmdaData.name})`,
      email: user.email, // Keep super admin's email
      phone: user.phone, // Keep super admin's phone
      status: 'active',
      mmda_id: mmdaData.mmda_id,
      mmda_name: mmdaData.name,
      // Add a flag to indicate this is a super admin session
      is_super_admin_session: true,
      original_user: user // Store original super admin user data
    };

    console.log('Switching to MMDA dashboard for:', mmdaData.name);
    console.log('MMDA User object:', mmdaUser);

    // Call the parent function to change user state
    if (onUserChange) {
      onUserChange(mmdaUser);
    }
  };

  // Fetch role name by ID
  const fetchRoleName = async (roleId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/roles/${roleId}`, API_CONFIG);
      const roleName = response.data.role_name || response.data.name || 'Unknown Role';
      // Format role name to be more readable (remove underscores and capitalize words)
      return roleName.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
    } catch (err) {
      console.error(`Failed to fetch role name for ID ${roleId}:`, err);
      return 'Unknown Role';
    }
  };

  // Fetch user name by ID
  const fetchUserName = async (userId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/users/${userId}`, API_CONFIG);
      return response.data.full_name || response.data.email || `User ${userId}`;
    } catch (err) {
      console.error(`Failed to fetch user name for ID ${userId}:`, err);
      return `User ${userId}`;
    }
  };

  // Fetch zone name by ID
  const fetchZoneName = async (zoneId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/zones/${zoneId}`, API_CONFIG);
      return response.data.zone_name || `Zone ${zoneId}`;
    } catch (err) {
      console.error(`Failed to fetch zone name for ID ${zoneId}:`, err);
      return `Zone ${zoneId}`;
    }
  };

  // Fetch group name by ID
  const fetchGroupName = async (groupId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/zonal-groups/${groupId}`, API_CONFIG);
      return response.data.group_name || `Group ${groupId}`;
    } catch (err) {
      console.error(`Failed to fetch group name for ID ${groupId}:`, err);
      return `Group ${groupId}`;
    }
  };

  // Fetch data for selected table or dashboard
  const fetchData = async () => {
    if (selectedTable.name === 'Dashboard') {
      setLoading(true);
      setError('');
      setErrorDetails('');

      try {
        // Ensure roles and mmdas are loaded first
        if (roles.length === 0) {
          await fetchAllRoles();
        }
        if (mmdas.length === 0) {
          await fetchAllMmdas();
        }

        // Get today's date in YYYY-MM-DD format
        const today = new Date().toISOString().split('T')[0];

        // Fetch all required data
        const [usersRes, transactionsRes, mmdasRes, zonesRes, groupsRes] = await Promise.all([
          axios.get(API_BASE_URL + '/users', API_CONFIG),
          axios.get(`${API_BASE_URL}/transactions?date=${today}`, API_CONFIG),
          axios.get(API_BASE_URL + '/mmdas', API_CONFIG),
          axios.get(API_BASE_URL + '/zones', API_CONFIG),
          axios.get(API_BASE_URL + '/zonal-groups', API_CONFIG),
        ]);

        const usersData = Array.isArray(usersRes.data) ? usersRes.data : usersRes.data.data || [];
        const transactionsData = Array.isArray(transactionsRes.data) ? transactionsRes.data : transactionsRes.data.data || [];
        const mmdasData = Array.isArray(mmdasRes.data) ? mmdasRes.data : mmdasRes.data.data || [];
        const zonesData = Array.isArray(zonesRes.data) ? zonesRes.data : zonesRes.data.data || [];
        const groupsData = Array.isArray(groupsRes.data) ? groupsRes.data : groupsRes.data.data || [];
        
        // Ensure role and mmda maps are updated
        const roleMap = new Map(roles.map(role => [role.role_id, role.role_name || role.name]));
        const mmdaMap = new Map(mmdas.map(mmda => [mmda.mmda_id, mmda.name]));
        
        setRoleMap(roleMap);
        setMmdaMap(mmdaMap);

        // Process user types data with proper role mapping
        const userTypes = usersData.reduce((acc, user) => {
          const roleName = roleMap.get(user.role_id) || 'Unknown Role';
          const existingType = acc.find(item => item.role_name === roleName);
          if (existingType) {
            existingType.user_count++;
          } else {
            acc.push({ role_name: roleName, user_count: 1 });
          }
          return acc;
        }, []);

        const mmdaZoneGroupData = [
          { name: 'MMDAs', count: mmdasData.length },
          { name: 'Zones', count: zonesData.length },
          { name: 'Groups', count: groupsData.length },
        ];

        // Process transaction data for pie chart
        const transactionDistribution = [
          { name: 'Successful', count: 0 },
          { name: 'Pending', count: 0 },
          { name: 'Failed', count: 0 }
        ];

        transactionsData.forEach(transaction => {
          const status = transaction.status?.toLowerCase() || 'pending';
          if (status === 'successful' || status === 'success') {
            transactionDistribution[0].count++;
          } else if (status === 'failed' || status === 'error') {
            transactionDistribution[2].count++;
          } else {
            transactionDistribution[1].count++;
          }
        });

        setDashboardData({
          usersCount: usersData.length,
          transactionsCount: transactionsData.length,
          mmdasCount: mmdasData.length,
          userTypesData: userTypes,
          mmdaZoneGroupData: mmdaZoneGroupData,
          transactionDistribution: transactionDistribution,
        });
        setLoading(false);
      } catch (err) {
        console.error('Failed to fetch dashboard data:', err);
        setError('Failed to fetch dashboard data');
        setErrorDetails(err.message || JSON.stringify(err));
        setLoading(false);
      }
    } else if (selectedTable.name === 'Email Settings' || selectedTable.name === 'Settings') {
      // Don't fetch data for Email Settings page
      setData([]);
      setLoading(false);
    } else {
      setLoading(true);
      setError('');
      setErrorDetails('');
      try {
        const res = await axios.get(API_BASE_URL + selectedTable.endpoint, API_CONFIG);
        let responseData = res.data;
        
        // If we're fetching users, map role IDs to role names
        if (selectedTable.name === 'Users') {
          console.log('Raw user data from backend:', responseData);
          console.log('Current roles state:', roles);

          // Create a fresh roleMap from current roles state
          const currentRoleMap = new Map(roles.map(role => [role.role_id, role.role_name || role.name]));
          console.log('Created roleMap:', currentRoleMap);

          const usersWithRoleNames = await Promise.all(
            responseData.map((user) => {
              console.log(`Processing user ${user.full_name}:`, user);
              console.log(`role_id=${user.role_id}, existing role_name=${user.role_name}`);
              const roleName = user.role_name || currentRoleMap.get(user.role_id) || 'Unknown Role';
              const mmdaName = mmdas.find(mmda => mmda.mmda_id === user.mmda_id)?.name || 'N/A';
              console.log(`Final role name for ${user.full_name}: ${roleName}`);
              const processedUser = {
                ...user,
                role_id: user.role_id, // Explicitly preserve role_id
                role_name: roleName,
                mmda_name: mmdaName
              };
              console.log(`Processed user ${user.full_name}:`, processedUser);
              return processedUser;
            })
          );
          console.log('Final processed users:', usersWithRoleNames);
          setData(usersWithRoleNames);
        } else if (selectedTable.name === 'Devices') {
          // For devices, the API already provides mmda_name and assigned_user_name
          // No need to map them again as it would override the correct values
          console.log('Devices data from API:', responseData.slice(0, 2)); // Debug log
          setData(responseData);
        } else if (selectedTable.name === 'MMDA Zones') {
          // Use the mmda_name already provided by the backend query
          setData(responseData);
        } else if (selectedTable.name === 'Revenue Officers') {
          const revenueOfficersWithMmdaNames = responseData.map(officer => ({
            ...officer,
            mmda_name: mmdas.find(mmda => mmda.mmda_id === officer.mmda_id)?.name || 'N/A'
          }));
          setData(revenueOfficersWithMmdaNames);
        } else if (selectedTable.name === 'Traders') {
         // The TradersView component now fetches its own dropdown data.
         // We only need to process the trader data itself.
         const tradersWithDetails = await Promise.all(
           responseData.map(async (trader) => {
             // These fetches are still needed to resolve names for display in the table
             const groupName = trader.group_id ? await fetchGroupName(trader.group_id) : 'N/A';
             const mmdaName = mmdas.find(mmda => mmda.mmda_id === trader.mmda_id)?.name || 'N/A';
             const zoneName = trader.zone_id ? await fetchZoneName(trader.zone_id) : 'N/A';
             return {
               ...trader,
               group_name: groupName,
               mmda_name: mmdaName,
               zone_name: zoneName,
             };
           })
         );
         setData(tradersWithDetails);
       } else if (selectedTable.name === 'Groups') {
         // Zone names are already included in the response from backend
         setData(responseData);
       } else {
          setData(responseData);
        }
      } catch (err) {
        setError('Failed to fetch data');
        setErrorDetails(err.message || JSON.stringify(err));
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    setCurrentPage(0); // Reset to the first page
    if (selectedTable) {
      setData([]); // Clear data immediately when selectedTable changes
      setLoading(true); // Set loading to true immediately
      fetchData();
    }
  }, [selectedTable, zones, editTrader, groups, mmdas, nationalIdTypes]);

  // Re-fetch dashboard data when roles or mmdas are loaded
  useEffect(() => {
    if (selectedTable.name === 'Dashboard' && roles.length > 0 && mmdas.length > 0) {
      fetchData();
    }
  }, [roles, mmdas, selectedTable.name]);

  useEffect(() => {
    if (selectedTable.name === 'MMDA Zones') {
      setCurrentPage(0);
    }
  }, [zoneStatusFilter]);

  // Reset current page when traders filters change
  useEffect(() => {
    if (selectedTable.name === 'Traders') {
      setCurrentPage(0);
    }
  }, [tradersStatusFilter, tradersMmdaFilter]);

  // Reset current page when groups filters change
  useEffect(() => {
    if (selectedTable.name === 'Groups') {
      setCurrentPage(0);
    }
  }, [groupsStatusFilter, groupsMmdaFilter]);

  // Reset current page when revenue officers filters change
  useEffect(() => {
    if (selectedTable.name === 'Revenue Officers') {
      setCurrentPage(0);
    }
  }, [revenueOfficersStatusFilter, revenueOfficersMmdaFilter]);

  // Reset current page when zones filters change
  useEffect(() => {
    if (selectedTable.name === 'MMDA Zones') {
      setCurrentPage(0);
    }
  }, [zoneStatusFilter, zoneMmdaFilter]);



  useEffect(() => {
    if (isEditDeviceModalOpen && editDevice) {
      setSelectedUser(editDevice.assigned_to);
      setSelectedMmda(editDevice.mmda_id);
    } else {
      setSelectedUser(null);
      setSelectedMmda(null);
    }
  }, [isEditDeviceModalOpen, editDevice]);

  // Filter data based on selected table and search terms
  let filteredData = data;
  
  // Apply filtering before pagination
  if (selectedTable.name === 'Users') {
    filteredData = data.filter(item => {
      const searchMatch = Object.values(item).some(val =>
        val?.toString().toLowerCase().includes(searchTerm.toLowerCase())
      );
      const statusMatch = statusFilter === 'All' || item.status === statusFilter;
      return searchMatch && statusMatch;
    });
  } else if (selectedTable.name === 'Devices') {
    filteredData = data.filter(item =>
      Object.values(item).some(val =>
        val?.toString().toLowerCase().includes(deviceSearchTerm.toLowerCase())
      )
    );
  } else if (selectedTable.name === 'MMDA Zones') {
    filteredData = data.filter(item => {
      const searchMatch = Object.values(item).some(val =>
        val?.toString().toLowerCase().includes(zoneSearchTerm.toLowerCase())
      );
      const statusMatch = zoneStatusFilter === 'All' || item.status === zoneStatusFilter;
      const mmdaMatch = zoneMmdaFilter === 'All' ||
        (item.mmda_name && item.mmda_name === zoneMmdaFilter);
      return searchMatch && statusMatch && mmdaMatch;
    });
  } else if (selectedTable.name === 'MMDA List') {
    filteredData = data;
  } else if (selectedTable.name === 'Groups') {
    filteredData = data.filter(item => {
      const searchMatch = Object.values(item).some(val =>
        val?.toString().toLowerCase().includes(groupsSearchTerm.toLowerCase())
      );
      const statusMatch = groupsStatusFilter === 'All' || item.status === groupsStatusFilter;
      const mmdaMatch = groupsMmdaFilter === 'All' ||
        (item.mmda_name && item.mmda_name === groupsMmdaFilter);
      return searchMatch && statusMatch && mmdaMatch;
    });
  } else if (selectedTable.name === 'Revenue Officers') {
    filteredData = data.filter(item => {
      const searchMatch = Object.values(item).some(val =>
        val?.toString().toLowerCase().includes(revenueOfficersSearchTerm.toLowerCase())
      );
      const statusMatch = revenueOfficersStatusFilter === 'All' || item.status === revenueOfficersStatusFilter;
      const mmdaMatch = revenueOfficersMmdaFilter === 'All' ||
        (item.mmda_name && item.mmda_name === revenueOfficersMmdaFilter);
      return searchMatch && statusMatch && mmdaMatch;
    })}
      else if (selectedTable.name === 'Traders') {
        filteredData = data.filter(item => {
          const searchMatch = Object.values(item).some(val =>
            val?.toString().toLowerCase().includes(tradersSearchTerm.toLowerCase())
          );
          // Make status filtering case-insensitive and handle variations
          const statusMatch = tradersStatusFilter === 'All' ||
            (item.status && item.status.toLowerCase() === tradersStatusFilter.toLowerCase());
          // MMDA filtering
          const mmdaMatch = tradersMmdaFilter === 'All' ||
            (item.mmda_name && item.mmda_name === tradersMmdaFilter);
          return searchMatch && statusMatch && mmdaMatch;
        });
  } else if (selectedTable.name === 'Payment Methods') {
    filteredData = data.filter(item =>
      Object.values(item).some(val =>
        val?.toString().toLowerCase().includes(paymentMethodSearchTerm.toLowerCase())
      )
    );
  } else if (selectedTable.name === 'Receipts') {
    filteredData = data.filter(item =>
      Object.values(item).some(val =>
        val?.toString().toLowerCase().includes(receiptSearchTerm.toLowerCase())
      )
    );
  } else if (selectedTable.name === 'Revenue Items') {
    filteredData = data.filter(item =>
      Object.values(item).some(val =>
        val?.toString().toLowerCase().includes(revenueItemSearchTerm.toLowerCase())
      )
    );
  } else if (selectedTable.name === 'Ticket Validations') {
    filteredData = data.filter(item =>
      Object.values(item).some(val =>
        val?.toString().toLowerCase().includes(ticketValidationSearchTerm.toLowerCase())
      )
    );
  } else if (selectedTable.name === 'Transactions') {
    filteredData = data.filter(item =>
      Object.values(item).some(val =>
        val?.toString().toLowerCase().includes(transactionSearchTerm.toLowerCase())
      )
    );
  } else if (selectedTable.name === 'USSD Sessions') {
    filteredData = data.filter(item =>
      Object.values(item).some(val =>
        val?.toString().toLowerCase().includes(ussdSessionSearchTerm.toLowerCase())
      )
    );
  } else if (selectedTable.name === 'Audit Logs') {
    filteredData = data.filter(item =>
      Object.values(item).some(val =>
        val?.toString().toLowerCase().includes(auditLogSearchTerm.toLowerCase())
      )
    );
  }

  const pageCount = Math.ceil(filteredData.length / ITEMS_PER_PAGE);
  const pagedFilteredData = filteredData.slice(currentPage * ITEMS_PER_PAGE, (currentPage + 1) * ITEMS_PER_PAGE);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderContent = () => {
    switch (selectedTable.name) {
      case 'Dashboard':
        return <DashboardView
          dashboardData={dashboardData}
          error={error}
          userTypesData={dashboardData.userTypesData}
          userInfo={user}
          API_BASE_URL={process.env.REACT_APP_API_BASE_URL}
          auth={API_CONFIG}
        />;
      case 'Email Settings':
        return <EmailSettingsView />;
      case 'Settings':
       return <SettingsView />;
      case 'Users':
        return (
          <UsersView
            pagedFilteredData={pagedFilteredData}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
            setIsAddUserModalOpen={setIsAddUserModalOpen}
            setEditUser={setEditUser}
            setIsEditModalOpen={setIsEditModalOpen}
            fetchData={fetchData}
            currentPage={currentPage}
            totalRows={filteredData.length}
            itemsPerPage={ITEMS_PER_PAGE}
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
            loading={loading}
            onManageSidebar={handleManageSidebar}
          />
        );
      case 'Devices':
        return (
          <DevicesView
            pagedFilteredData={pagedFilteredData}
            deviceSearchTerm={deviceSearchTerm}
            setDeviceSearchTerm={setDeviceSearchTerm}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
            setIsAddDeviceModalOpen={setIsAddDeviceModalOpen}
            setEditDevice={setEditDevice}
            setIsEditDeviceModalOpen={setIsEditDeviceModalOpen}
            loading={loading}
          />
        );
      case 'MMDA List':
        return (
          <MMDAsView
            pagedFilteredData={pagedFilteredData}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
            setIsAddMmdaModalOpen={setIsAddMmdaModalOpen}
            setEditMmda={setEditMmda}
            setIsEditMmdaModalOpen={setIsEditMmdaModalOpen}
            onMmdaLogin={handleMmdaLogin}
            loading={loading}
          />
        );
      case 'MMDA Zones':
       return (
         <ZonesView
           pagedFilteredData={pagedFilteredData}
           searchTerm={zoneSearchTerm}
           setSearchTerm={setZoneSearchTerm}
           pageCount={pageCount}
           handlePageClick={handlePageClick}
           setIsAddModalOpen={setIsAddModalOpen}
           setEditZone={setEditZone}
           setIsEditModalOpen={setIsEditZoneModalOpen}
           currentPage={currentPage}
           totalRows={filteredData.length}
           itemsPerPage={ITEMS_PER_PAGE}
           statusFilter={zoneStatusFilter}
           setStatusFilter={setZoneStatusFilter}
           mmdaFilter={zoneMmdaFilter}
           setMmdaFilter={setZoneMmdaFilter}
           mmdas={mmdas}
           onStatusUpdate={handleZoneStatusUpdate}
         />
       );
      case 'Groups':
        return (
          <GroupsView
            pagedFilteredData={pagedFilteredData}
            searchTerm={groupsSearchTerm}
            setSearchTerm={setGroupsSearchTerm}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
            setIsAddModalOpen={setIsAddModalOpen}
            setEditGroup={setEditGroup}
            setIsEditModalOpen={setIsEditGroupModalOpen}
            currentPage={currentPage}
            totalRows={filteredData.length}
            itemsPerPage={ITEMS_PER_PAGE}
            statusFilter={groupsStatusFilter}
            setStatusFilter={setGroupsStatusFilter}
            mmdaFilter={groupsMmdaFilter}
            setMmdaFilter={setGroupsMmdaFilter}
            mmdas={mmdas}
            fetchData={fetchAllGroups}
            showPopup={showPopup}
          />
        );
      case 'Revenue Officers':
        return (
          <RevenueOfficersView
            pagedFilteredData={pagedFilteredData}
            searchTerm={revenueOfficersSearchTerm}
            setSearchTerm={setRevenueOfficersSearchTerm}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
            setIsAddModalOpen={setIsAddRevenueOfficerModalOpen}
            setEditRevenueOfficer={setEditRevenueOfficer}
            setIsEditRevenueOfficerModalOpen={setIsEditRevenueOfficerModalOpen}
            editRevenueOfficer={editRevenueOfficer}
            zones={zones}
            mmdaOptions={mmdas.map(mmda => ({ value: mmda.mmda_id, label: mmda.name }))}
            userTypes={roles.map(role => ({ value: role.role_id, label: role.role_name || role.name }))}
            currentPage={currentPage}
            totalRows={filteredData.length}
            itemsPerPage={ITEMS_PER_PAGE}
            statusFilter={revenueOfficersStatusFilter}
            setStatusFilter={setRevenueOfficersStatusFilter}
            mmdaFilter={revenueOfficersMmdaFilter}
            setMmdaFilter={setRevenueOfficersMmdaFilter}
            mmdas={mmdas}
            showPopup={showPopup}
            fetchData={fetchData}
            API_BASE_URL={API_BASE_URL}
          />
        );
      case 'Traders':
       return (
         <TradersView
           pagedFilteredData={pagedFilteredData}
           searchTerm={tradersSearchTerm}
           setSearchTerm={setTradersSearchTerm}
           pageCount={pageCount}
           handlePageClick={handlePageClick}
           setIsAddModalOpen={setIsAddModalOpen}
           setEditTrader={setEditTrader}
           setIsEditModalOpen={setIsEditTraderModalOpen}
           currentPage={currentPage}
           totalRows={filteredData.length}
           itemsPerPage={ITEMS_PER_PAGE}
           statusFilter={tradersStatusFilter}
           setStatusFilter={setTradersStatusFilter}
           mmdaFilter={tradersMmdaFilter}
           setMmdaFilter={setTradersMmdaFilter}
           showPopup={showPopup}
           fetchData={fetchData}
           API_BASE_URL={API_BASE_URL}
           groups={groups}
           mmdas={mmdas}
           zones={zones}
           nationalIdTypes={nationalIdTypes}
         />
       );
      case 'Payment Methods':
        return (
          <PaymentMethodsView
            pagedFilteredData={pagedFilteredData}
            searchTerm={paymentMethodSearchTerm}
            setSearchTerm={setPaymentMethodSearchTerm}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
            setIsAddModalOpen={setIsAddModalOpen}
            setEditPaymentMethod={setEditPaymentMethod}
            setIsEditModalOpen={setIsEditPaymentMethodModalOpen}
          />
        );
      case 'Receipts':
        return (
          <ReceiptsView
            pagedFilteredData={pagedFilteredData}
            searchTerm={receiptSearchTerm}
            setSearchTerm={setReceiptSearchTerm}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
            setIsAddModalOpen={setIsAddModalOpen}
            setEditReceipt={setEditReceipt}
            setIsEditModalOpen={setIsEditReceiptModalOpen}
          />


        );
      case 'Revenue Items':
        return (
          <RevenueItemsView
            pagedFilteredData={pagedFilteredData}
            searchTerm={revenueItemSearchTerm}
            setSearchTerm={setRevenueItemSearchTerm}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
            setIsAddModalOpen={setIsAddModalOpen}
            setEditRevenueItem={setEditRevenueItem}
            setIsEditModalOpen={setIsEditRevenueItemModalOpen}
          />
        );
      case 'Ticket Validations':
        return (
          <TicketValidationsView
            pagedFilteredData={pagedFilteredData}
            searchTerm={ticketValidationSearchTerm}
            setSearchTerm={setTicketValidationSearchTerm}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
            setIsAddModalOpen={setIsAddModalOpen}
            setEditTicketValidation={setEditTicketValidation}
            setIsEditModalOpen={setIsEditTicketValidationModalOpen}
          />
        );
      case 'Transactions':
        return (
          <TransactionsView
            pagedFilteredData={pagedFilteredData}
            searchTerm={transactionSearchTerm}
            setSearchTerm={setTransactionSearchTerm}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
            setIsAddModalOpen={setIsAddModalOpen}
            setEditTransaction={setEditTransaction}
            setIsEditModalOpen={setIsEditTransactionModalOpen}
          />
        );
      case 'USSD Sessions':
        return (
          <UssdSessionsView
            pagedFilteredData={pagedFilteredData}
            searchTerm={ussdSessionSearchTerm}
            setSearchTerm={setUssdSessionSearchTerm}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
            setIsAddModalOpen={setIsAddModalOpen}
            setEditUssdSession={setEditUssdSession}
            setIsEditModalOpen={setIsEditUssdSessionModalOpen}
          />
        );
      case 'Audit Logs':
        return (
          <AuditLogsView
            pagedFilteredData={pagedFilteredData}
            searchTerm={auditLogSearchTerm}
            setSearchTerm={setAuditLogSearchTerm}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
          />
        );
      case 'Support':
        return (
          <SupportTicketsView
            userInfo={user}
            API_BASE_URL={process.env.REACT_APP_API_BASE_URL}
            auth={API_CONFIG}
          />
        );
      default:
        return <div style={{ color: 'white' }}>Select a table to view data</div>;
    }
  };

  const showPopup = (message, type) => {
    setPopup({ message, type });
    setTimeout(() => {
      setPopup({ message: '', type: '' });
    }, 3000);
  };

  return (
    <div style={{ display: 'flex', height: '100vh', backgroundColor: '#f5f5f5' }}>
      {/* Enhanced Popup Notification */}
      {popup.message && (
        <div
          style={{
            position: 'fixed',
            top: 24,
            right: 24,
            padding: '16px 24px',
            borderRadius: 12,
            backgroundColor: popup.type === 'success' ? '#4caf50' : '#f44336',
            color: 'white',
            zIndex: 10000,
            boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
            fontSize: 14,
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            minWidth: 300,
            animation: 'slideInRight 0.3s ease'
          }}
        >
          <div style={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: 'rgba(255,255,255,0.8)'
          }} />
          {popup.message}
        </div>
      )}

      {/* Enhanced Sidebar */}
      <Sidebar
        selectedTable={selectedTable}
        setSelectedTable={setSelectedTable}
        setPage={setPage}
        tables={tables}
        user={user}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        deviceSearchTerm={deviceSearchTerm}
        setDeviceSearchTerm={setDeviceSearchTerm}
        paymentMethodSearchTerm={paymentMethodSearchTerm}
        setPaymentMethodSearchTerm={setPaymentMethodSearchTerm}
        receiptSearchTerm={receiptSearchTerm}
        setReceiptSearchTerm={setReceiptSearchTerm}
        revenueItemSearchTerm={revenueItemSearchTerm}
        setRevenueItemSearchTerm={setRevenueItemSearchTerm}
        ticketValidationSearchTerm={ticketValidationSearchTerm}
        setTicketValidationSearchTerm={setTicketValidationSearchTerm}
        transactionSearchTerm={transactionSearchTerm}
        setTransactionSearchTerm={setTransactionSearchTerm}
        ussdSessionSearchTerm={ussdSessionSearchTerm}
        setUssdSessionSearchTerm={setUssdSessionSearchTerm}
        auditLogSearchTerm={auditLogSearchTerm}
        setAuditLogSearchTerm={setAuditLogSearchTerm}
      />

      {/* Main Content Area */}
      <main style={{ flexGrow: 1, padding: 20, overflowY: 'auto', maxWidth: 'calc(100% - 280px)' }}>
        <Header user={user} handleLogout={handleLogout} />
        <h2 style={{
          marginBottom: 20,
          color: '#1976d2',
          fontWeight: 'bold',
          fontSize: 28,
          display: 'flex',
          alignItems: 'center',
          gap: 12
        }}>
          {selectedTable.name || 'Dashboard'}
        </h2>
        {renderContent()}

        <style jsx>{`
          @keyframes slideInRight {
            from {
              opacity: 0;
              transform: translateX(100px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }
        `}</style>

        <AddDeviceModal
          isOpen={isAddDeviceModalOpen}
          onClose={() => setIsAddDeviceModalOpen(false)}
          users={users}
          mmdas={mmdas}
          showPopup={showPopup}
          fetchData={fetchData}
          API_BASE_URL={API_BASE_URL}
        />

        <AddMmdaModal
          isOpen={isAddMmdaModalOpen}
          onClose={() => setIsAddMmdaModalOpen(false)}
          showPopup={showPopup}
          fetchData={fetchData}
          API_BASE_URL={API_BASE_URL}
        />

        <AddGroupModal
          isOpen={isAddModalOpen}
          onClose={() => setIsAddModalOpen(false)}
          showPopup={showPopup}
          fetchData={fetchData}
          API_BASE_URL={API_BASE_URL}
          zones={zones}
        />

        <EditGroupModal
          isOpen={isEditGroupModalOpen}
          onClose={() => setIsEditGroupModalOpen(false)}
          showPopup={showPopup}
          fetchData={fetchData}
          API_BASE_URL={API_BASE_URL}
          editGroup={editGroup}
          zones={zones}
        />

        <AddRevenueOfficerModal
         isOpen={isAddRevenueOfficerModalOpen}
         onClose={() => setIsAddRevenueOfficerModalOpen(false)}
         showPopup={showPopup}
         fetchData={fetchData}
         API_BASE_URL={API_BASE_URL}
         mmdas={mmdas}
         zones={zones}
       />

        <EditTraderModal
          isOpen={isEditTraderModalOpen}
          onClose={() => setIsEditTraderModalOpen(false)}
          showPopup={showPopup}
          fetchData={fetchData}
          API_BASE_URL={API_BASE_URL}
          editTrader={editTrader}
          groups={groups}
          mmdas={mmdas}
          zones={zones}
          nationalIdTypes={nationalIdTypes}
        />
        
        <EditRevenueOfficerModal
          isOpen={isEditRevenueOfficerModalOpen}
          onClose={() => setIsEditRevenueOfficerModalOpen(false)}
          showPopup={showPopup}
          fetchData={fetchData}
          API_BASE_URL={API_BASE_URL}
          editRevenueOfficer={editRevenueOfficer}
          zones={zones}
          mmdaOptions={mmdas.map(mmda => ({ value: mmda.mmda_id, label: mmda.name }))}
          userTypes={roles.map(role => ({ value: role.role_id, label: role.role_name || role.name }))}
        />
        
        <EditZoneModal
          isOpen={isEditZoneModalOpen}
          onClose={() => setIsEditZoneModalOpen(false)}
          zone={editZone}
          onUpdate={fetchData}
        />
        
        <AddUserModal
          isOpen={isAddUserModalOpen}
          onClose={() => setIsAddUserModalOpen(false)}
          showPopup={showPopup}
          fetchData={fetchData}
          API_BASE_URL={API_BASE_URL}
          roles={roles}
          mmdas={mmdas}
          API_CONFIG={API_CONFIG}
        />
        <EditUserModal
          isOpen={isEditModalOpen}
          onClose={() => setIsEditModalOpen(false)}
          editUser={editUser}
          showPopup={showPopup}
          fetchData={fetchData}
          API_BASE_URL={API_BASE_URL}
          API_CONFIG={API_CONFIG}
          roles={roles}
          mmdas={mmdas}
        />
        {/* New Device Edit Modal */}
        {isEditDeviceModalOpen && editDevice && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(0,0,0,0.4)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000,
            }}
            onClick={() => setIsEditDeviceModalOpen(false)}
          >
            <div
              style={{
                backgroundColor: '#fff',
                padding: 15,
                borderRadius: 12,
                
                maxWidth: '100%',
                maxHeight: '100%',
                overflowY: 'auto',
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                color: '#222',
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
                alignItems: 'stretch',
              }}
              onClick={e => e.stopPropagation()}
            >
              <h3 style={{ marginTop: 0, marginBottom: 12, color: '#1976d2', fontSize: 16, textAlign: 'center' }}>Edit Device</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-start', paddingLeft: 20, paddingRight: 20 }}>
                <label style={{ fontWeight: '600', color: '#1976d2', textAlign: 'left', width: 260, fontSize: 14 }}>Device Serial:</label>
                <input
                  type="text"
                  ref={deviceSerialRef}
                  defaultValue={editDevice.device_serial}
                  style={{
                  width: 260,
                  padding: '8px 14px',
                  borderRadius: 6,
                  border: '1px solid #ccc',
                  fontSize: 14,
                  fontWeight: '100',
                  outline: 'none',
                  color: '#444',
                  }}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-start', paddingLeft: 20, paddingRight: 20 }}>
                <label style={{ fontWeight: '600', color: '#1976d2', textAlign: 'left', width: 260, fontSize: 14 }}>Assigned To:</label>
                <SearchableDropdown
                  options={users.map((user) => ({
                    value: user.user_id,
                    label: user.full_name,
                  }))}
                  value={selectedUser}
                  onChange={(value) => setSelectedUser(value)}
                  placeholder="Select User"
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-start', paddingLeft: 20, paddingRight: 20 }}>
                <label style={{ fontWeight: '600', color: '#1976d2', textAlign: 'left', width: 260, fontSize: 14 }}>Mmdas:</label>
                <SearchableDropdown
                  options={mmdas.map((mmda) => ({
                    value: mmda.mmda_id,
                    label: mmda.name,
                  }))}
                  value={selectedMmda}
                  onChange={(value) => setSelectedMmda(value)}
                  placeholder="Select MMDA"
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-start', paddingLeft: 20, paddingRight: 20 }}>
                <label style={{ fontWeight: '600', color: '#1976d2', textAlign: 'left', width: 260, fontSize: 14 }}>Status:</label>
                <input
                  type="text"
                  ref={deviceStatusRef}
                  defaultValue={editDevice.status}
                  style={{
                  width: 260,
                  padding: '8px 14px',
                  borderRadius: 6,
                  border: '1px solid #ccc',
                  fontSize: 14,
                  fontWeight: '100',
                  outline: 'none',
                  color: '#444',
                  }}
                />
              </div>
              <button
                onClick={async () => {
                  try {
                    const updatedDeviceData = {
                      ...editDevice,
                      device_serial: deviceSerialRef.current.value,
                      status: deviceStatusRef.current.value,
                      assigned_to: selectedUser,
                      mmda_id: selectedMmda,
                    };

                    await axios.put(`${API_BASE_URL}/devices/${editDevice.device_id}`, updatedDeviceData, API_CONFIG);

                    fetchData();
                    setIsEditDeviceModalOpen(false);
                    showPopup('Device updated successfully!', 'success');
                  } catch (err) {
                    console.error('Failed to update device:', err);
                    showPopup('Failed to update device. Please try again.', 'error');
                  }
                }}
                style={{
                  width: 80,
                  height: 28,
                  backgroundColor: '#1976d2',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 6,
                  
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: 14,
                  transition: 'background-color 0.3s ease',
                  outline: 'none',
                  alignSelf: 'flex-start',
                  marginLeft: 20,
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.backgroundColor = '#1565c0';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(21, 101, 192, 0.9)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.backgroundColor = '#1976d2';
                  e.currentTarget.style.boxShadow = '0 6px 16px rgba(25, 118, 210, 0.7)';
                }}
              >
                Update
              </button>
            </div>
          </div>
        )}
        {/* New MMDA Edit Modal */}
        {isEditMmdaModalOpen && editMmda && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(0,0,0,0.4)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000,
            }}
            onClick={() => setIsEditMmdaModalOpen(false)}
          >
            <div
              style={{
                backgroundColor: '#fff',
                padding: 15,
                borderRadius: 12,
                
                maxWidth: '100%',
                maxHeight: '100%',
                overflowY: 'auto',
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                color: '#222',
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
                alignItems: 'stretch',
              }}
              onClick={e => e.stopPropagation()}
            >
              <h3 style={{ marginTop: 0, marginBottom: 12, color: '#1976d2', fontSize: 16, textAlign: 'center' }}>Edit Mmdas</h3>
               <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-start', paddingLeft: 20, paddingRight: 20 }}>
                <label style={{ fontWeight: '600', color: '#1976d2', textAlign: 'left', width: 260, fontSize: 14 }}>Mmda Name:</label>
                <input
                  type="text"
                  ref={mmdaNameRef}
                  defaultValue={editMmda.name}
                  style={{
                  width: 260,
                  padding: '8px 14px',
                  borderRadius: 6,
                  border: '1px solid #ccc',
                  fontSize: 14,

                  outline: 'none',
                  color: '#444',
                  }}
                />
              </div>
               <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-start', paddingLeft: 20, paddingRight: 20 }}>
                <label style={{ fontWeight: '600', color: '#1976d2', textAlign: 'left', width: 260, fontSize: 14 }}>District Code:</label>
                <input
                  type="text"
                  ref={districtCodeRef}
                  defaultValue={editMmda.district_code}
                  style={{
                  width: 260,
                  padding: '8px 14px',
                  borderRadius: 6,
                  border: '1px solid #ccc',
                  fontSize: 14,
                  outline: 'none',
                  color: '#444',
                  }}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-start', paddingLeft: 20, paddingRight: 20 }}>
                <label style={{ fontWeight: '600', color: '#1976d2', textAlign: 'left', width: 260, fontSize: 14 }}>Region:</label>
                <input
                  type="text"
                  ref={regionRef}
                  defaultValue={editMmda.region}
                  style={{
                  width: 260,
                  padding: '8px 14px',
                  borderRadius: 6,
                  border: '1px solid #ccc',
                  fontSize: 14,
                  outline: 'none',
                  color: '#444',
                  }}
                />
              </div>
               <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-start', paddingLeft: 20, paddingRight: 20 }}>
                <label style={{ fontWeight: '600', color: '#1976d2', textAlign: 'left', width: 260, fontSize: 14 }}>Created At:</label>
                <input
                  type="text"
                  defaultValue={editMmda.created_at}
                  readOnly
                  style={{
                  width: 260,
                  padding: '8px 14px',
                  borderRadius: 6,
                  border: '1px solid #ccc',
                  fontSize: 14,
                  backgroundColor: '#f0f0f0',
                  outline: 'none',
                  color: '#444',
                  }}
                />
              </div>
              <button
                onClick={async () => {
                  try {
                    const updatedMmdaData = {
                      ...editMmda,
                      name: mmdaNameRef.current.value,
                      district_code: districtCodeRef.current.value,
                      region: regionRef.current.value,
                    };

                    await axios.put(`${API_BASE_URL}/mmdas/${editMmda.mmda_id}`, updatedMmdaData, API_CONFIG);

                    fetchData();
                    setIsEditMmdaModalOpen(false);
                    showPopup('MMDA updated successfully!', 'success');
                  } catch (err) {
                    console.error('Failed to update MMDA:', err);
                    showPopup('Failed to update MMDA. Please try again.', 'error');
                  }
                }}
                style={{
                  width: 80,
                  height: 28,
                  backgroundColor: '#1976d2',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 6,
                  
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: 14,
                  transition: 'background-color 0.3s ease',
                  outline: 'none',
                  alignSelf: 'flex-start',
                  marginLeft: 20,
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.backgroundColor = '#1565c0';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(21, 101, 192, 0.9)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.backgroundColor = '#1976d2';
                  e.currentTarget.style.boxShadow = '0 6px 16px rgba(25, 118, 210, 0.7)';
                }}
              >
                Update
              </button>
            </div>
          </div>
        )}

        {/* User Sidebar Permissions Modal */}
        <UserSidebarPermissionsModal
          isOpen={isUserSidebarPermissionsModalOpen}
          onClose={() => {
            setIsUserSidebarPermissionsModalOpen(false);
            setSelectedUserForSidebar(null);
          }}
          user={selectedUserForSidebar}
          showPopup={showPopup}
        />
      </main>
    </div>
  );
};

export default SuperAdminDashboard;

